import {
  Box,
  Button,
  Collapse,
  Flex,
  Image,
  SlideFade,
  Stack,
  Text,
} from '@chakra-ui/react';
import { BsBellFill } from 'react-icons/bs';
import icon from '../../assets/icon.svg';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import {
  getEstateDue,
  getEstateDues,
  getEvent,
  getManagerAnnouncement,
} from './service';
import { AuthContext } from '../../context/authContext';
import FullPageLoader from '../../components/FullPageLoader';
import EstateDueCard from './components/EstateDueCard';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Footer from '../../components/footer';
import { PROTECTED_PATHS } from '../../app/constants';
import SingleNewsCard from './components/SingleNewsCard';
import HeadSeemore from '../../components/HeadSeemore';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { v4 } from 'uuid';
import { transition } from '../..';

const MyEstate = () => {
  const navigate = useNavigate();
  const [estateDue, setEstateDue] = useState([]);
  const [estateDues, setEstateDues] = useState([]);
  const [events, setEvents] = useState([]);
  const { userInfo } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const { userId } = userInfo;
  const [announcements, setAnnouncements] = useState([]);
  const { INVITE_GUEST } = PROTECTED_PATHS;

  useEffect(() => {
    getEstateDue(userId, setEstateDue, setLoading);
    getEstateDues(setLoading, setEstateDues, userId);
    getEvent(userId, setLoading, setEvents);
    getManagerAnnouncement(setLoading, userId, setAnnouncements);
  }, [userId]);

  return loading ? (
    <FullPageLoader />
  ) : (
    <SlideFade in={true} offsetY='500px' {...transition}>
      <Stack pb='12vh'>
        <Stack bg='#FAF6FF' pt='5' mb='10'>
          <Container>
            <Header menu />
            <Box
              bg='primary'
              borderRightRadius='30px'
              p='15px'
              pos='relative'
              left={['-12%']}
              bottom='-5'
              w='70%'
            >
              <Flex
                justify='space-between'
                align='center'
                cursor='pointer'
                pl='5'
                onClick={() => navigate(INVITE_GUEST)}
              >
                <Stack cursor='pointer'>
                  <Text color='#B7B6B6' fontStyle='italic'>
                    Click here to
                  </Text>
                  <Text color='#FFFFFF' fontSize='1rem'>
                    Invite Guest
                  </Text>
                </Stack>
                <Image src={icon} alt='Profile icon' h='50px' />
              </Flex>
            </Box>
          </Container>
        </Stack>

        <Container>
          <Flex
            bg='red.100'
            justify='space-between'
            align='center'
            p='3'
            borderRadius='10px'
            border='1px solid #FC7067'
          >
            <Box flex={1} pl='1rem' textAlign='center'>
              <BsBellFill size={25} color='#9A82B8' />
            </Box>
            <Stack flex={5}>
              <Flex gap='0.5rem' align='center'>
                <Stack>
                  <Text color='#516395' fontSize='12px' fontWeight='600'>
                    From the Manager's desk
                  </Text>
                  {announcements?.slice(0, 2)?.map((announcement) => (
                    <AnouncementText
                      key={announcement._id}
                      announcement={announcement}
                    />
                  ))}
                </Stack>
              </Flex>
            </Stack>
          </Flex>
        </Container>
        <Container>
          <EstateDueCard estateDue={estateDue} estateDues={estateDues} />
        </Container>

        <Container>
          <Stack spacing='5' mb='5'>
            {/* <HeadSeemore head='News/Events' seemore to={NEWS_EVENTS} /> */}
            <HeadSeemore head='News/Events' />

            <CarouselProvider
              infinite={true}
              visibleSlides={3}
              dragEnabled={true}
              isPlaying={true}
              naturalSlideWidth={100}
              naturalSlideHeight={100}
              totalSlides={events?.length}
            >
              <Slider>
                {events?.map((event, index) => (
                  <Slide key={v4()} index={index}>
                    <SingleNewsCard {...event} />
                  </Slide>
                ))}
              </Slider>
            </CarouselProvider>
          </Stack>
        </Container>
        <Footer />
      </Stack>
    </SlideFade>
  );
};

export default MyEstate;

const AnouncementText = ({ announcement }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Collapse startingHeight={18} in={show}>
        {announcement.body}
      </Collapse>
      <Button
        variant='link'
        _focus={{ border: 'none' }}
        w='70px'
        size='xs'
        onClick={() => setShow(!show)}
        mt='1rem'
      >
        Show {show ? 'Less' : 'More'}
      </Button>
    </>
  );
};
